var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(1 == 2)?_c('Advertising'):_vm._e(),_c('div',{staticClass:"pa-4"},[_c('PriceTable')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }